namespace advisorop.components.common {

    export class AccountGroupingListController {

        public accounts: Array<domains.IAccount>;
        public dg: DevExpress.ui.dxDataGridOptions;
        public dataGrid: DevExpress.ui.dxDataGrid;
        //events
        onAccountSelected: any;

        static $inject = ["$scope"];
        constructor(private advisorService: services.AdvisorService, private $scope: ng.IScope) {

            this.dg = {
                export: {
                    enabled: true,
                    fileName: "Accounts"
                },
                bindingOptions: {
                    dataSource: "vm.accounts"
                },
                onInitialized: function (e) {
                    this.vm.dataGrid = e.component;
                },
                //height: "300px",
                //paging: {
                //    pageSize: 50,
                //    enabled: true
                //},
                scrolling: {
                    mode: "standard",
                    showScrollbar: "always", //onScroll
                    useNative: true
                },
                rowAlternationEnabled: true,
                showBorders: true,
                showColumnLines: true,
                columnAutoWidth: true,
                allowColumnReordering: true,
                allowColumnResizing: true,
                noDataText: "Account list is empty",
                filterRow: { visible: true },
                headerFilter: { visible: false },
                searchPanel: {
                    visible: false,
                    width: 240,
                    placeholder: 'Search...'
                },
                wordWrapEnabled: true,
                columns: [
                    { dataField: 'name', caption: 'Title' },
                    { dataField: 'number', caption: 'Number', width: 90 },
                    { dataField: 'statusDescription', caption: 'Status', width: 90 },
                ],
                selection: {
                    mode: "multiple",
                    showCheckBoxesMode: "always",
                },
                //onSelectionChanged: function (selectedItems) {
                //    var data = selectedItems.selectedRowsData[0];
                //    if (data) {
                //        this.vm.selectAccount(data);
                //    }
                //}
            };
        }

        selectAccount(account): void {
            this.onAccountSelected({ account: account });
        };
        

        $onInit(): void {
            this.receviceMoveEvent();
        }

        // move event
        receviceMoveEvent() {
            let that = this
            this.$scope.$on('moveAccounts', function () {
                //console.log("received the moveAccountEvent.")
                let accountsToMove = that.dataGrid.getSelectedRowsData();
                accountsToMove.forEach(account => {
                    that.selectAccount(account);
                })
            });
        }
    }
    
    class AccountGroupingList implements ng.IComponentOptions {

        public bindings: any;
        public controller: any;
        public controllerAs: string;
        public templateUrl: string;

        constructor() {
            this.bindings = {
                accounts: "<",
                onAccountSelected: "&"
            };
            this.controller = ["advisorService", "$scope", AccountGroupingListController];
            this.controllerAs = "vm";
            this.templateUrl = 'spa/shared/common/account-grouping-list.html';
        }
    }
    angular.module(Constants.APP).component("accountGroupingList", new AccountGroupingList());

}